<!-- Don't forget to use '.sync' with visible prop in parent component -->
<template>
  <v-dialog
    :value="visible"
    width="500px"
    max-width="500px"
    ref="dialog"
    @close="$emit('update:visible', false)"
    @click:outside="$emit('update:visible', false)"
  >
    <v-card ref="card" class="pa-4">
      <chip-radio
        v-model="medium"
        :options="
          Object.values(this.$mediums).map((medium) => ({
            label: userFriendlyMediumWord(medium, true),
            value: medium,
          }))
        "
      ></chip-radio>
      <media-search :medium="medium" @workSelected="onWorkSelected"></media-search>
    </v-card>
  </v-dialog>
</template>

<script>
import mediaSearch from "./media-search.vue";
import chipRadio from "./chip-radio.vue";
import { userFriendlyMediumWord } from "../util/mediumHelpers";

export default {
  name: "media-search-popup",

  props: {
    visible: Boolean,
  },

  components: {
    mediaSearch,
    chipRadio,
  },

  data: function () {
    return {
      searchTerm: "",
      medium: this.$mediums.FILM,
    };
  },

  methods: {
    userFriendlyMediumWord,

    onWorkSelected(event) {
      this.$emit("workSelected", event);
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__title {
  padding: 10px 10px 6px;
  font-size: 24px;
  font-weight: bold;
  line-height: 1;
}
</style>
